import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import more from 'highcharts/highcharts-more';
more(Highcharts);
import * as moment from 'moment/moment';
import { AlertService } from './../../providers/alert.service';
moment.locale('ja');

/**
 * Generated class for the RangeGraphComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'range-graph',
  templateUrl: 'range-graph.html'
})
export class RangeGraphComponent implements OnInit, AfterViewInit {

  chart: any;
  chartId: string;
  
  @Input() plotBands: any[];
  @Input() series: any[];

  // 開始日時
  @Input() start: number;
  // 終了日時
  @Input() end: number;
  // ポイントの間隔 (mill seconds)
  @Input() pointInterval: number;
  // デフォルト背景色
  @Input() bgColor: string;
  // 選択中背景色
  @Input() bgColorSelected: string;
  // 入力対象
  @Input() target: 'sleep' |  'wakeup';
  // 開始変更可能
  @Input() startEnabled: boolean;
  // 終了変更可能
  @Input() endEnabled: boolean;

  selectedRange: { start: number, end: number } = { start: null, end: null}

  @Output() changeRange: EventEmitter<{ start: number, end: number }> = new EventEmitter();

  isShowViewInit: boolean = false;

  constructor(
    private alertService: AlertService,
  ) {
    console.log('Hello RangeGraphComponent Component');
  }

  ngOnInit() {
    this.chartId = 'range-graph-' + Math.random().toString(36).slice(-8);
    this.selectedRange.start = this.start;
    this.selectedRange.end = this.end;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.isShowViewInit) {
      return;
    }
    if (changes.target) {
      this.target = changes.target.currentValue;
    }
    if (changes.start) {
      this.selectedRange.start = changes.start.currentValue;
    }
    if (changes.end) {
      this.selectedRange.end = changes.end.currentValue;
    }
    if (changes.startEnabled) {
      this.startEnabled = changes.startEnabled.currentValue;
    }
    if (changes.endEnabled) {
      this.endEnabled = changes.endEnabled.currentValue;
    }
    this.eventCall(false);
  }

  ngAfterViewInit() {

    let componentScope = this;

    this.chart = Highcharts.chart(this.chartId, {

      renderTo: 'container',

      chart: {
        height: 100,
      },
      credits: false,
      title: {
        text: null
      },
      legend:{
        disabled: false
      },

      boost: {
        useGPUTranslations: true,
      },

      plotOptions: {
        line: {
          turboThreshold: 1000000,
          pointRange: 1
        },
        series:{
          turboThreshold: 200000,
          point: {
            events: {
              mouseOver: function(){

                const ua = navigator.userAgent;
                if((ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) || ua.indexOf('iPad') > 0) {
                  componentScope.changeSelected(this);
                }
              }
            }
          }
        }
      },
  
      xAxis: {
        plotBands: this.plotBands,
        type: 'datetime',
        // gridZIndex: 0,

        title: {
          text: null
        },
        // 3時間単位で表示する
        tickInterval: 3*3600*1000,

        labels: {
          formatter: function() {
            var val = this.value + 32400000; // UTC -> JSTに変換する
            return  Highcharts.dateFormat('%H:%M', val);
          }
        }
      },
  
      yAxis: {
        title: {
          text: null
        },
        visible: false,
        max: 1,
        min: 0,
        tickInterval: 1,
        height: 50,
      },
  
      tooltip: {
        crosshairs: true,
        shared: true,
        formatter: function () {
          console.log(this);
          let text = moment(this.x).format('HH時mm分');
          // TODO: 状態を取れるようになりたい...
          // if (this.color === "#fff") {
          //   text += ' 離床中';
          // } else {
          //   text += ' 離床中';
          // }
          return text;
        }
      },

      series: [
        {
          type: 'line',
          id: 'respirations',
          renderTo: this.chartId,
          dashStyle: 'none',
          animation: false,
          zIndex: 1000,
          name: null,
          showInLegend: false,
          data: this.series,
          pointStart: this.plotBands[0].from,
          pointInterval: this.pointInterval, // 10分毎
          lineWidth: 0,
          endOnTick: true,
          followTouchMove: true,
          marker: {
            enabled: false
          },
          accessibility: {
            keyboardNavigation: {
              enabled: true
            }
          },
          allowPointSelect: true,
          color: "#F9F9F9",
          states: {
            hover: {
              lineWidthPlus: 0,
              halo: {
                size: 20,
                attributes: {
                    fill: '#000',
                    stroke: '#F9F9F9',
                }
              },
              animation: {
                duration: 0,
                easing: "unset"
              }
            }
          },
          events: {
            click: function (event) {
              componentScope.changeSelected(event.point);
            }
          }
        },
      ]
    });

    this.plotBands.push({
      id: "id",
      color: this.bgColorSelected,
      from: this.selectedRange.start,
      to: this.selectedRange.end? this.selectedRange.end: this.selectedRange.start,
      zIndex: 100,
    });
    this.chart.xAxis[0].update({
      plotBands: this.plotBands,
      // tickInterval: 1000 * 60, // one day
      type: 'datetime'
    });
    this.chart.redraw();


    this.isShowViewInit = true;

  }

  changeSelected(event) {

    // 起床・睡眠時間 既に入力済みの場合
    if (!this.startEnabled &&!this.endEnabled) {
      return; 
    }
    // 睡眠時間 既に入力済みの場合
    if (this.target === 'sleep' && !this.startEnabled) {
      return;
    }
    // 起床時間 既に入力済みの場合
    if (this.target === 'wakeup' && !this.endEnabled) {
      return;
    }
    // 入力対象が選択されていない場合
    if (!this.target) {
      this.alertService.basic('就寝、もしくは起床を選択してください', '', () => {});
      return;
    }

    // 仕様は3つ
    // ① 開始時間のみ選択可能
    if (this.startEnabled && !this.endEnabled) {
      // 起床時間より早い時間を選択した場合
      if (this.selectedRange.end < event.x) {
        this.alertService.basic('起床時間より早い時間を選択してください', '', () => {});
        return;
      }
    }
    // ② 終了時間のみ選択可能
    if (!this.startEnabled && this.endEnabled) {
      // 就寝時間より遅い時間を選択した場合
      if (this.selectedRange.start > event.x) {
        this.alertService.basic('就寝時間より遅い時間を選択してください', '', () => {});
        return;
      }
    }
    // ③ 両方選択可能
    if (this.startEnabled && this.endEnabled) {
      if (this.target === 'sleep' && this.selectedRange.end && this.selectedRange.end < event.x) {
        // 起床時間より早い時間を選択した場合
        this.alertService.basic('起床時間より早い時間を選択してください', '', () => {});
        return;
      }
      if (this.target === 'wakeup' && this.selectedRange.start && this.selectedRange.start > event.x) {
        // 就寝時間より遅い時間を選択した場合
        this.alertService.basic('就寝時間より遅い時間を選択してください', '', () => {});
        return;
      }
    }

    // データをセット
    if (this.target === 'sleep') {
      this.selectedRange.start = event.x;
    } else {
      this.selectedRange.end = event.x;
    }
    this.eventCall();
  }

  private eventCall(isEmit: boolean = true) {

    this.plotBands = this.plotBands.filter(p =>  p.id !== 'id')
    this.plotBands.push({
      id: "id",
      color: this.bgColorSelected,
      from: this.selectedRange.start,
      to: this.selectedRange.end? this.selectedRange.end: this.selectedRange.start,
      zIndex: 1,
    });
    this.chart.xAxis[0].update({
      plotBands: this.plotBands,
      // tickInterval: 1000 * 60, // one day
      type: 'datetime'
    });
    this.chart.redraw()

    if (isEmit) {
      // 呼び出し元に通知
      this.changeRange.emit(this.selectedRange);
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/range-graph/range-graph.ts